import * as Yup from 'yup';

export const ChangePasswordOnSignInSchema = Yup.object().shape({
    // token: Yup.string().required('Token is required'),
    newPassword: Yup.string().min(8).required('Please provide your password'),
    confirmPassword: Yup.string()
        .required()
        .oneOf([Yup.ref('newPassword')], 'Passwords do not match'),
});

export type ChangePasswordOnSignInDataType = Yup.InferType<
    typeof ChangePasswordOnSignInSchema
>;

type InitialValues = {
    // token: string;
    newPassword: string;
    confirmPassword: string;
};

export const changePasswordOnSignInInitialValues: InitialValues = {
    // token: '',
    newPassword: '',
    confirmPassword: '',
};

export interface IChangePassword {
    token: string;
    newPassword: string;
    confirmPassword: string;
}
